var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M518.0416 516.3008m-451.1744 0a451.1744 451.1744 0 1 0 902.3488 0 451.1744 451.1744 0 1 0-902.3488 0Z",
    fill: "#aaaaf8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.4064 473.0368h377.7024c15.1552 0 28.928-8.9088 35.072-22.784 6.144-13.8752 3.584-30.0544-6.5536-41.3184l-82.5344-91.5968a38.38976 38.38976 0 0 0-54.2208-2.816c-15.7696 14.1824-16.9984 38.5024-2.816 54.2208l24.7808 27.4944H322.4064c-21.1968 0-38.4 17.2032-38.4 38.4s17.2032 38.4 38.4 38.4zM700.1088 559.5136H322.4064c-15.1552 0-28.928 8.9088-35.072 22.784-6.144 13.8752-3.584 30.0544 6.5536 41.3184l82.5344 91.5968a38.38976 38.38976 0 0 0 54.2208 2.816c15.7696-14.1824 16.9984-38.5024 2.816-54.2208l-24.7808-27.4944h291.3792c21.1968 0 38.4-17.2032 38.4-38.4s-17.152-38.4-38.3488-38.4z",
    fill: "#FFCD43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.d147a0c928d7cd714ffd8e4472386e0a.svg";
export { ForwardRef as ReactComponent };